import { render, staticRenderFns } from "./arviointityokalu.vue?vue&type=template&id=052e4c28&scoped=true&"
import script from "./arviointityokalu.vue?vue&type=script&lang=ts&"
export * from "./arviointityokalu.vue?vue&type=script&lang=ts&"
import style0 from "./arviointityokalu.vue?vue&type=style&index=0&id=052e4c28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052e4c28",
  null
  
)

export default component.exports